<mojo-viewbar></mojo-viewbar>
<mojo-page-title [title]="pageTitle$ | async"></mojo-page-title>

  <section class="panel full-page-widget mojo-admin-page data-table full-page-scrollable">
    <div class="panel-body">
      <mojo-client-profile-table [clientsProfiles]="clientParentsProfiles$ | async" [loading]="(clientParentsLoading$ | async) || (profileLoading$ | async)" (onRowClicked)="clientParentSelected($event)"></mojo-client-profile-table>
    </div>
  </section>

  <mojo-client-parent-editor [profiles]="profiles$ | async" [dialogTitle]="dialogTitle" (onSaveComplete)="saveComplete($event)"></mojo-client-parent-editor>

